import React, { useEffect, useMemo, useState } from 'react';
import { Autocomplete, Box, Button, Card, CardContent, CircularProgress, Divider, Stack, TextField, Typography } from '@mui/material';
import GlobalDialog from '../../../components/mui/Dialogue/GlobalDialog';
import { Icon } from '@iconify/react/dist/iconify.js';
import { useSelector } from 'react-redux';
import { getActiveEnrollments } from '../../../redux/features/studentPortalSlice';
import { useDispatch } from 'react-redux';

const ActiveCourses = ({ rowData, dispatchData, open, setOpen }) => {

  const {loading,activeCourses} = useSelector((state) => state.studentPortal);
  const dispatch = useDispatch();

  useEffect(()=>{
    dispatch(getActiveEnrollments(rowData?.admission_number))
  },[])

  return (
    <GlobalDialog
      title={'Active Courses'}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={'sm'}
      closeButton={true}
      content={
        <>
          <Box>
            {loading && (
                <Stack alignItems={"center"} justifyContent={"center"} py={2} spacing={2} direction={"column"}>
                <CircularProgress/>
                <Typography variant='caption'>Loading Data...</Typography>
                </Stack>
            )}
            {activeCourses?.length === 0 && !loading &&(
                <Card
              sx={{
                mb: 1,
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                borderRadius: 3,
                color: '#fff',
                boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
              }}
            >
                <Stack
                alignItems="center"
                justifyContent="center"
                spacing={1.5}
                sx={{ py: 3 }}
              >
                <Box
                  sx={{
                    width: 56,
                    height: 56,
                    borderRadius: '50%',
                    bgcolor: 'rgba(0,0,0,0.06)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Icon
                    icon="mdi:book-off-outline"
                    width={28}
                    height={28}
                    style={{ opacity: 0.8 }} 
                  />
                </Box>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 600, fontSize: '0.9rem', opacity: 1 }}
                >
                  No Active Courses
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontSize: '0.78rem', opacity: 0.8, textAlign: 'center', maxWidth: 300 }}
                >
                  There are currently no active courses for this student.
                </Typography>
              </Stack>
              </Card>
            )}
            {activeCourses?.length > 0 && !loading &&(
            <Card
              sx={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                borderRadius: 3,
                color: '#fff',
                boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
              }}
            >
              <CardContent sx={{ py: 2, px: 2.5 }}>
                {/* Card Header */}
                <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }}>
                  <Icon icon="mdi:book-open-variant" width={20} height={20} />
                  <Typography variant="subtitle1" sx={{ fontWeight: 700, fontSize: '0.95rem' }}>
                    Active Courses & Assigned CROs
                  </Typography>
                </Stack>

                {/* Course List */}
                <Stack spacing={0}>
                  {activeCourses.map((course, index) => (
                    <React.Fragment key={course.cro_assignment_id}>
                      {index > 0 && <Divider sx={{ borderColor: 'rgba(255,255,255,0.15)', my: 0.8 }} />}
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        alignItems="flex-start"
                        justifyContent="space-between"
                        sx={{
                          py: 0.6,
                          px: 1.5,
                          borderRadius: 1.5,
                          '&:hover': { bgcolor: 'rgba(255,255,255,0.08)' },
                          transition: 'background 0.2s ease',
                        }}
                      >
                        {/* Course Name */}
                        <Stack direction="row" alignItems="center" spacing={1} sx={{ flex: 1 }}>
                          <Icon icon="mdi:school-outline" width={16} height={16} style={{ opacity: 0.8 }} />
                          <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '0.82rem' }}>
                            {course.course_name}
                          </Typography>
                        </Stack>

                        {/* CRO Name */}
                        <Stack direction="row" alignItems="center" spacing={0.8} sx={{ flex: 1 }}>
                          <Icon icon="mdi:account-outline" width={15} height={15} style={{ opacity: 0.8 }} />
                          <Typography variant="body2" sx={{ fontSize: '0.8rem', opacity: 0.95 }}>
                            {course.cro_name === null ? "Not Assigned" : course.cro_name}
                          </Typography>
                        </Stack>
                      </Stack>
                    </React.Fragment>
                  ))}
                </Stack>
              </CardContent>
            </Card>
            )}
          </Box>
        </>
      }
    />
  );
};

export default ActiveCourses;
